import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import PrivateRoute from "../components/routing/PrivateRoute";
import "./App.css";
import Dashboard from "../pages/Dashboard";
import SignIn from "../pages/SignIn";

// import { Admin, Resource } from "react-admin";
// import simpleRestProvider from "ra-data-simple-rest";
// import { PostList, PostShow, PostCreate, PostEdit } from "../pages/Posts";
// import { UserList, UserShow, UserCreate, UserEdit } from "../pages/Users";
// import {
//   FirebaseDataProvider,
//   FirebaseAuthProvider,
// } from "react-admin-firebase";
// import UserIcon from "@material-ui/icons/People";

// import CustomLoginPage from "../pages/CustomLoginPage";
// import firebase from "firebase";

// const config = {
//   apiKey: "AIzaSyC2ziHWvF7_4KPzv9cJ324EK5ss-tQF63c",
//   authDomain: "iqsys-354ae.firebaseapp.com",
//   projectId: "iqsys-354ae",
//   storageBucket: "iqsys-354ae.appspot.com",
//   messagingSenderId: "550351278456",
//   appId: "1:550351278456:web:3af29475e614f48674788d",
// };
// const firebaseApp = firebase.initializeApp(config);
// const options = {};
// const dataProvider = FirebaseDataProvider(config, options);
// const authProvider = FirebaseAuthProvider(config, {
//   logging: true,
//   // rootRef: 'rootrefcollection/QQG2McwjR2Bohi9OwQzP',
//   app: firebaseApp,
//   // watch: ['posts'];
//   // dontwatch: ['comments'];
//   persistence: "local",
//   // disableMeta: true
//   dontAddIdFieldToDoc: true,
//   lazyLoading: {
//     enabled: true,
//   },
//   firestoreCostsLogger: {
//     enabled: true,
//   },
// });
export const Role = {
  Admin: "admin",
  User: "user",
  Moderator: "moderator",
};

function App() {
  return (
    <Router>
      <div className="app">
        <Switch>
          <Route exact path="/" component={Dashboard} />
          <PrivateRoute
            roles={[Role.Admin, Role.Moderator]}
            exact
            path="/farmers"
            component={Dashboard}
          />
          <Route exact path="/farmers/:id/crops" component={Dashboard} />
          <PrivateRoute
            roles={[Role.Admin]}
            exact
            path="/users"
            component={Dashboard}
          />
          {/* <PrivateRoute exact path="/sites" component={Dashboard} />
          <PrivateRoute exact path="/daily-activities" component={Dashboard} />
          <PrivateRoute exact path="/site-cost" component={Dashboard} />
          <PrivateRoute exact path="/salary" component={Dashboard} />
          <PrivateRoute exact path="/cheque-issue" component={Dashboard} />
          <PrivateRoute exact path="/cheque-deposit" component={Dashboard} />
          <PrivateRoute exact path="/daily-expense" component={Dashboard} /> */}
          <Route exact path="/login" component={SignIn} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
